import { memo } from 'react'
import BetTableAAA from './BetTableAAA'
import BetTableAAA2 from './BetTableAAA2'
import BetTableAB20 from './BetTableAB20'
import BetTableAB4 from './BetTableAB4'
import BetTableABJ from './BetTableABJ'
import BetTableBaccarat from './BetTableBaccarat'
import BetTableBaccarat2 from './BetTableBaccarat2'
import BetTableBallByBall from './BetTableBallByBall'
import BetTableBtable from './BetTableBtable'
import BetTableBtable2 from './BetTableBtable2'
import BetTableCard32 from './BetTableCard32'
import BetTableCard32EU from './BetTableCard32EU'
import BetTableDT20 from './BetTableDT20'
import BetTableDT6 from './BetTableDT6'
import BetTableDTL20 from './BetTableDTL20'
import BetTableDoliDana from './BetTableDoliDana'
import BetTableDum10 from './BetTableDum10'
import BetTableGoal from './BetTableGoal'
import BetTableGoal2 from './BetTableGoal2'
import BetTableJoker1 from './BetTableJoker1'
import BetTableJoker120 from './BetTableJoker120'
import BetTableJoker20 from './BetTableJoker20'
import BetTableLucky15 from './BetTableLucky15'
import BetTableLucky7 from './BetTableLucky7'
import BetTableMogambo from './BetTableMogambo'
import BetTableNoteNum from './BetTableNoteNum'
import BetTablePoison from './BetTablePoison'
import BetTablePoker20 from './BetTablePoker20'
import BetTablePoker6 from './BetTablePoker6'
import BetTableQueen from './BetTableQueen'
import BetTableRace17 from './BetTableRace17'
import BetTableRace2 from './BetTableRace2'
import BetTableRace20 from './BetTableRace20'
import BetTableRoulette12 from './BetTableRoulette12'
import BetTableSicBo2 from './BetTableSicBo2'
import BetTableTeen1 from './BetTableTeen1'
import BetTableTeen120 from './BetTableTeen120'
import BetTableTeen20 from './BetTableTeen20'
import BetTableTeen20b from './BetTableTeen20b'
import BetTableTeen20c from './BetTableTeen20c'
import BetTableTeen41 from './BetTableTeen41'
import BetTableTeen6 from './BetTableTeen6'
import BetTableTeen62 from './BetTableTeen62'
import BetTableTeensin from './BetTableTeensin'
import BetTableTrap from './BetTableTrap'
import BetTableTrio from './BetTableTrio'
import BetTableWar from './BetTableWar'
import BetTableWorli from './BetTableWorli'

import BetTable3CardJ from './BetTable3CardJ'
import BetTableInstantTeenpatti3 from './BetTableInstantTeenpatti3'
import BetTableLucky6 from './BetTableLucky6'
import BetTableMeter from './BetTableMeter'
import BetTableMuflis from './BetTableMuflis'
import BetTablePokerOneDay from './BetTablePokerOneDay'
import BetTableTeen1Day from './BetTableTeen1Day'
import BetTableTeenpatti2Cards from './BetTableTeenpatti2Cards'
import BetTableTeenpattiOpen from './BetTableTeenpattiOpen'
import BetTableTeenpattiTest from './BetTableTeenpattiTest'
import BetTableUniqueTeenpatti from './BetTableUniqueTeenpatti'
import BetTableWorli3 from './BetTableWorli3'

// gtype -> bet-table component (auto-mapped from the user-site components;
// games needing extra props get refined one-by-one in the casino build loop)
const TABLES = {
  '3cardj': BetTable3CardJ,
  teen33: BetTableInstantTeenpatti3,
  teen32: BetTableInstantTeenpatti3,
  lucky5: BetTableLucky6,
  cmeter: BetTableMeter,
  teenmuf: BetTableMuflis,
  poker: BetTablePokerOneDay,
  teen: BetTableTeen1Day,
  patti2: BetTableTeenpatti2Cards,
  teen8: BetTableTeenpattiOpen,
  teen9: BetTableTeenpattiTest,
  teenunique: BetTableUniqueTeenpatti,
  worli3: BetTableWorli3,
  aaa: BetTableAAA,
  aaa2: BetTableAAA2,
  ab20: BetTableAB20,
  ab4: BetTableAB4,
  abj: BetTableABJ,
  baccarat: BetTableBaccarat,
  baccarat2: BetTableBaccarat2,
  ballbyball: BetTableBallByBall,
  btable: BetTableBtable,
  btable2: BetTableBtable2,
  card32: BetTableCard32,
  card32eu: BetTableCard32EU,
  dt20: BetTableDT20,
  dt6: BetTableDT6,
  dtl20: BetTableDTL20,
  dolidana: BetTableDoliDana,
  dum10: BetTableDum10,
  goal: BetTableGoal,
  goal2: BetTableGoal2,
  joker1: BetTableJoker1,
  joker120: BetTableJoker120,
  joker20: BetTableJoker20,
  lucky15: BetTableLucky15,
  lucky7: BetTableLucky7,
  mogambo: BetTableMogambo,
  notenum: BetTableNoteNum,
  poison: BetTablePoison,
  poker20: BetTablePoker20,
  poker6: BetTablePoker6,
  queen: BetTableQueen,
  race17: BetTableRace17,
  race2: BetTableRace2,
  race20: BetTableRace20,
  roulette12: BetTableRoulette12,
  sicbo2: BetTableSicBo2,
  sicbo: BetTableSicBo2,
  teen1: BetTableTeen1,
  teen120: BetTableTeen120,
  teen20: BetTableTeen20,
  teen20b: BetTableTeen20b,
  teen20c: BetTableTeen20c,
  teen41: BetTableTeen41,
  teen42: BetTableTeen41,
  teen6: BetTableTeen6,
  teen62: BetTableTeen62,
  teensin: BetTableTeensin,
  trap: BetTableTrap,
  trio: BetTableTrio,
  war: BetTableWar,
  worli: BetTableWorli,
}

function BetTableSwitch({ gameType, gameData, onBet, exposures, ...rest }) {
  const Table = TABLES[gameType]
  if (!Table) {
    return (
      <div className="text-center my-3">
        <b>{gameType}</b> table UI pending — casino build loop me add hoga
      </div>
    )
  }
  return <Table gameData={gameData} onBet={onBet} exposures={exposures} {...rest} />
}

export default memo(BetTableSwitch)
